<template>
  <div>
    <el-form ref="formRef" :model="channelForm" label-width="200px">
      <el-form-item label="渠道：">
        {{channelForm.channel}}
      </el-form-item>
      <el-form-item label="上传头像：">
        <el-radio-group v-model="channelForm.isUploadHead">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="是否有审核版：">
        <el-radio-group v-model="channelForm.isHadCheck">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="是否开启广告：">
        <el-radio-group v-model="channelForm.isOpenAd">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div class="dialog-footer">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" v-loading="loading">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData } from "@/api/api"
import { updateChannelInfo } from "@/api/url";

export default {
  name: "TagManageDialog",
  props: {
    value: Object
  },
  data() {
    return {
      channelForm: this.value.channelForm,
      idx: this.value.ids,
      loading: false,
    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    //更改或添加
    headImgUpdate() {
      this.$refs.headImg.click();
    },

    //选取图片
    headImgChanged(e) {
      if(e.target.files[0]) {
        this.files = e.target.files[0];
        var windowURL = window.URL || window.webkitURL;
        this.src = windowURL.createObjectURL(this.files);
      }
    },

    summit() {
      // if(!this.channelForm.name) {
      //   this.$message({
      //     showClose: true,
      //     duration: 2000,
      //     message: '话题名称不能为空',
      //     type: 'warning'
      //   });
      //   return false
      // }
      // if(!this.channelForm.orderNum) {
      //   this.$message({
      //     showClose: true,
      //     duration: 2000,
      //     message: '排序不能为空',
      //     type: 'warning'
      //   });
      //   return false
      // }
      this.loading = true
      let param = {};
      param['id'] = this.channelForm.id?this.channelForm.id:0;
      param['isUploadHead'] = this.channelForm.isUploadHead;
      param['isHadCheck'] = this.channelForm.isHadCheck;
      param['isOpenAd'] = this.channelForm.isOpenAd;
      postFormData(updateChannelInfo, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    }
  },
  mounted() {
  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  float: left;
}
</style>
